import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UsuarioService } from '../services/UsuarioService';

const RutaProtegida = ({ permiso, children }) => {
  const { usuario, token, setUsuario } = useAuth();
  const [verificando, setVerificando] = useState(true);
  const [autorizado, setAutorizado] = useState(false);

  useEffect(() => {
    const verificarPermisos = async () => {
      try {
        const permisos = await UsuarioService.consultarPermisosPorUsuario({
          token,
          id: usuario.id,
        });
        // ✅ Actualiza el usuario en el contexto y localStorage
        const usuarioActualizado = {
          ...usuario,
          permisos,
        };
        setUsuario(usuarioActualizado);
        localStorage.setItem('user', JSON.stringify(usuarioActualizado));
        setAutorizado(permisos.includes(permiso));
      } catch (error) {
        console.error('Error al verificar permisos:', error);
        setAutorizado(false);
      } finally {
        setVerificando(false);
      }
    };

    verificarPermisos();
  }, [permiso, usuario.id, token]);

  if (verificando) return null; // o un spinner

  if (!autorizado) return <Navigate to="/no-autorizado" replace />;

  return children;
};

export default RutaProtegida;
